import axios from 'axios';

const API_URL = 'https://embarque-oriental-api-hqdtefdvbfdxbzcg.centralus-01.azurewebsites.net/api';
const api = axios.create({ baseURL: API_URL });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('usuario');
      window.location.href = '/';
    }
    return Promise.reject(error);
  }
);

export const getTasaCambio = () => api.get('/Configuracion/tasa-cambio');
export const deleteFurgon = (id) => api.delete(`/Furgones/${id}`);
export const updateTasaCambio = (data) => api.put('/Configuracion/tasa-cambio', data);
export const login = (data) => api.post('/Auth/login', data);
export const forgotPassword = (data) => api.post('/Auth/forgot-password', data);
export const resetPassword = (data) => api.post('/Auth/reset-password', data);
export const getFacturas = (page = 1, pageSize = 20, buscar = '', estado = '', ciudad = '', furgon = '') =>
  api.get(`/Facturas?page=${page}&pageSize=${pageSize}&buscar=${buscar}&estado=${estado}&ciudad=${ciudad}&furgon=${furgon}`);
export const getFactura = (id) => api.get(`/Facturas/${id}`);
export const getDashboardStats = (furgon = '') => api.get(`/Facturas/dashboard-stats?furgon=${furgon}`);
export const createFactura = (data) => api.post('/Facturas', data);
export const updateFactura = (id, data) => api.put(`/Facturas/${id}`, data);
export const anularFactura = (id, data) => api.put(`/Facturas/${id}/anular`, data);
export const cambiarEstadoEnvio = (id, data) => api.put(`/Facturas/${id}/estado-envio`, data);
export const cambiarEstadoPago = (id, data) => api.put(`/Facturas/${id}/estado-pago`, data);
export const getClientes = () => api.get('/Clientes');
export const createCliente = (data) => api.post('/Clientes', data);
export const updateCliente = (id, data) => api.put(`/Clientes/${id}`, data);
export const getPagos = () => api.get('/Pagos');
export const getPagosByFactura = (facturaId) => api.get(`/Pagos/factura/${facturaId}`);
export const createPago = (data) => api.post('/Pagos', data);
export const deletePago = (id) => api.delete(`/Pagos/${id}`);
export const getUsuarios = () => api.get('/Usuarios');
export const createUsuario = (data) => api.post('/Usuarios', data);
export const toggleUsuario = (id) => api.put(`/Usuarios/${id}/toggle`);
export const getFurgones = () => api.get('/Furgones');
export const createFurgon = (data) => api.post('/Furgones', data);
export const updateFurgon = (id, data) => api.put(`/Furgones/${id}`, data);
export const getAuditoria = () => api.get('/Auditoria');

export default api;